import React from 'react';
import {
  plusicon,
  searchnormal,
} from '../../imagepath';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SearchInput from '../../Forms/SearchInput';
import { Button, Checkbox, Tooltip } from 'antd';
// const { Option } = Select;

const ListTableToolbar = ({ onAdd, onSearch, onRefresh, hideAddAction, showHasFilter = false, hasRushFilter = false, setHasRushStatusFilter = () => {}}) => {
  return (
    <div className="page-table-header mb-2">
      <div className="row align-items-center">
        <div className="col">
          <div className="doctor-table-blk">
            <div className="doctor-search-blk">
              <div className="top-nav-search table-search-blk">
                <form>
                  <SearchInput
                    className="form-control"
                    onSearchChange={onSearch}
                  />
                  <Link className="btn">
                    <img src={searchnormal} alt="#" />
                  </Link>
                </form>
              </div>
              <div className="add-group">
                {showHasFilter && (
                  <Checkbox
                    className="ms-2"
                    checked={hasRushFilter}
                    onChange={(e) => setHasRushStatusFilter(e.target.checked)}
                  >
                    Rush Only
                  </Checkbox>
                )}
              </div>
              <div className="add-group">
                {!hideAddAction ? <Link
                  onClick={(e) => {
                    e?.preventDefault();
                    onAdd();
                  }}
                  className="btn btn-primary add-pluss ms-2"
                >
                  <img src={plusicon} alt="#" />
                </Link>: null}
                <Tooltip title="Refresh List">
                  <Button
                    onClick={(e) => {
                      e?.preventDefault();
                      onRefresh();
                    }}
                    className="ms-2"
                  >
                    Refresh
                  </Button>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ListTableToolbar.propTypes = {
  onAdd: PropTypes.func,
  onSearch: PropTypes.func,
  onRefresh: PropTypes.func,
  hideAddAction: PropTypes.bool,
  showHasFilter: PropTypes.bool,
  hasRushFilter: PropTypes.bool,
  setHasRushStatusFilter: PropTypes.func,
};

export default ListTableToolbar;
